export const getCountryFlagUrl = (flagCode) => {
  return `https://flagcdn.com/w40/${flagCode?.toLowerCase()}.png`;
};
